import { Button, Tooltip } from 'antd';
import React from 'react';

export const ToolbarButton = React.memo(({ children, ...props }) => {
  return (
    <Tooltip styles={{ body: { fontSize: '13px' } }} arrow={false} placement="topLeft" title={props['aria-label']}>
      <Button {...props}>{children}</Button>
    </Tooltip>
  );
});

export default ToolbarButton;
